<template>
    <DashboardLayout :user="user">
        <div class="border border-gray-300 bg-white rounded-lg shadow-lg max-w-4xl mx-auto pb-10">
            <!-- Header: My Accounts (Aligned Left) -->
            <div class="bg-gray-200 text-lg font-semibold px-6 py-3 rounded-t-lg text-left">
                Payment
            </div>

            <div class="max-w-3xl mx-auto bg-white border border-gray-300 rounded-lg shadow-lg px-6 py-4 mt-5">
                <div class="text-gray-700 text-2xl font-bold text-left">Payment</div>
                <p class="text-gray-700 text-left">Complete the payment process below</p>

                <div class="mt-4">
                    <p class="text-lg font-bold">Account Number: {{ beneficiary.accountNumber }}</p>
                    <p class="text-lg font-bold">Bank: {{ beneficiary.bank }}</p>
                </div>

                <div v-if="beneficiary.bank === 'DMC Bank'" class="mt-4">
                    <p class="text-lg font-bold">Total Balance: ₹{{ balance }}</p>
                    <input v-model="amount" type="number" placeholder="Enter Amount"
                        class="w-1/2 px-3 py-2 border rounded mt-2" />
                    <button @click="sendAmount"
                        class="mt-3 px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-500">
                        Send Amount
                    </button>
                </div>

                <div v-else class="mt-4">
                    <p class="text-lg font-bold">Select Payment Method:</p>
                    <select v-model="paymentMethod" class="w-1/2 px-3 py-2 border rounded mt-2">
                        <option value="">Select</option>
                        <option value="NEFT">NEFT</option>
                        <option value="RTGS">RTGS</option>
                        <option value="IMPS">IMPS</option>
                    </select>

                    <div v-if="paymentMethod" class="mt-4">
                        <p class="text-lg font-bold">Total Balance: ₹{{ balance }}</p>
                        <input v-model="amount" type="number" placeholder="Enter Amount"
                            class="w-1/2 px-3 py-2 border rounded mt-2" />
                        <button @click="sendAmount"
                            class="mt-3 px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-500">
                            Send Amount
                        </button>
                    </div>
                </div>
            </div>



        </div>
    </DashboardLayout>

</template>

<script>


import DashboardLayout from "@/components/DashboardLayout.vue";

export default {
    name: 'BeneficiaryPayment',
    components: {
        DashboardLayout
    },
    data() {
        return {
            user: {},
            beneficiary: {},
            balance: 50000, // Example balance
            paymentMethod: "",
            amount: null
        };
    },
    computed: {

    },
    created() {
        const userData = localStorage.getItem('user');
        if (!userData) {
            alert("Session expired. Please log in again.");
            this.$router.push("/");
            return;
        }
        this.user = JSON.parse(userData);

        const storedBeneficiary = sessionStorage.getItem("selectedBeneficiary");
        if (storedBeneficiary) {
            this.beneficiary = JSON.parse(storedBeneficiary);
        } else {
            this.$router.push("/beneficiaries");
        }
    },
    methods: {
        sendAmount() {
            if (!this.amount || this.amount <= 0) {
                alert("Enter a valid amount");
                return;
            }
            alert(`₹${this.amount} sent successfully via ${this.paymentMethod || "DMC"}!`);
        }
    }
}

</script>
